"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinUrls = exports.stringToBoolean = void 0;

var stringToBoolean = function stringToBoolean(stringValue) {
  var _stringValue$toLowerC, _stringValue$toLowerC2;

  switch (stringValue === null || stringValue === void 0 ? void 0 : (_stringValue$toLowerC = stringValue.toLowerCase) === null || _stringValue$toLowerC === void 0 ? void 0 : (_stringValue$toLowerC2 = _stringValue$toLowerC.call(stringValue)) === null || _stringValue$toLowerC2 === void 0 ? void 0 : _stringValue$toLowerC2.trim()) {
    case "true":
    case "yes":
    case "1":
      return true;

    case "false":
    case "no":
    case "0":
    case null:
    case undefined:
      return false;

    default:
      return JSON.parse(stringValue);
  }
};

exports.stringToBoolean = stringToBoolean;

var joinUrls = function joinUrls() {
  for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
    urls[_key] = arguments[_key];
  }

  var joinedUrl = urls.map(function (url) {
    return url.replace(/(^\/|\/$)/g, '');
  });
  return joinedUrl.join('/');
};

exports.joinUrls = joinUrls;